import React from 'react';
import { ArrowRight } from 'lucide-react';
import { isLocalQaPreview } from '../lib/authVisualPreview';

export default function LocalPreviewAccess() {
  if (!isLocalQaPreview()) return null;
  const visual = document.documentElement.dataset.authPreview === 'classic' ? 'classic' : 'modern';
  return <aside className="auth-local-preview" aria-label="Acesso à demonstração local">
    <strong>Prévia local</strong>
    <p>Explore com uma conta fictícia. Você não precisa informar seu e-mail ou senha.</p>
    <a href={'/__qa/profile?visual=' + visual + '&role=admin&path=/dashboard'} data-testid="local-preview-access">
      Abrir painel de demonstração <ArrowRight size={16} aria-hidden />
    </a>
  </aside>;
}
